import { render } from "./MovieView.vue?vue&type=template&id=17c275c1&scoped=true"
import script from "./MovieView.vue?vue&type=script&lang=js"
export * from "./MovieView.vue?vue&type=script&lang=js"

import "./MovieView.vue?vue&type=style&index=0&id=17c275c1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c275c1"]])

export default __exports__